module.exports = __webpack_public_path__ + "static/fonts/spaceranger3d.12b1c6a.ttf";